var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00003 16C8.59557 16 8.23093 16.2437 8.07615 16.6173C7.92137 16.991 8.00692 17.4211 8.29292 17.7071L11.2929 20.7071C11.4805 20.8947 11.7348 21 12 21C12.2653 21 12.5196 20.8947 12.7071 20.7071L15.7071 17.7071C15.9931 17.4211 16.0787 16.991 15.9239 16.6173C15.7691 16.2436 15.4045 16 15 16L9.00003 16Z",
    fill: "#152C70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 2C4.23858 2 2 4.23858 2 7V13C2 15.7614 4.23858 18 7 18H17C19.7614 18 22 15.7614 22 13V7C22 4.23858 19.7614 2 17 2H7Z",
    fill: "#4296FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8C6 7.44772 6.44772 7 7 7H15C15.5523 7 16 7.44772 16 8C16 8.55228 15.5523 9 15 9H7C6.44772 9 6 8.55228 6 8Z",
    fill: "#152C70"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C6 11.4477 6.44772 11 7 11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H7C6.44772 13 6 12.5523 6 12Z",
    fill: "#152C70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.2aa85c05d445625e893a974a8f1f7492.svg";
export { ForwardRef as ReactComponent };